/**
 * 全局混入：代表队报名提交后锁定，不可修改
 *
 * 使用方式（全局注册，各页面无需引入）：
 *   模板中禁用控件：  :disabled="isTeamSubmitted"
 *   方法中拦截操作：  if (this.checkTeamLock()) return;
 */

// 代表队提交状态枚举
export const TEAM_STATUS = {
  NOT_SUBMITTED: 1, // 未提交（可编辑）
  SUBMITTED: 2,     // 已提交（锁定，不可修改）
}

export default {
  computed: {
    // 是否已提交锁定：兼容各页面的 teamInfo（prop）与 projectSum 内部维护的 teamInfoVo
    isTeamSubmitted() {
      return [this.teamInfo, this.teamInfoVo].some(
        (info) => info && Number(info.status) === TEAM_STATUS.SUBMITTED
      )
    },
  },
  methods: {
    // 操作守卫：已提交时弹出提示并返回 true，用于方法入口拦截
    checkTeamLock(tip) {
      if (!this.isTeamSubmitted) {
        return false
      }
      this.$message.warning(tip || this.$t('common.submittedLockTip'))
      return true
    },
  },
}
